export default "__VITE_ASSET__638027f4__$_?nuxt_component=async__"